import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup
  .object({
    name: yup
      .string()
      .required('Name is required')
      .trim()
      .min(1, 'Name must be at least 1 character'),
  })
  .required()

const resEditEmailTemplate = yupResolver(schema)

export default resEditEmailTemplate
